module.exports = __webpack_public_path__ + "media/icon/icon-download-2-green-8f12ae1c.svg";